import { render, staticRenderFns } from "./KnEditForm.vue?vue&type=template&id=dd864ade"
import script from "./KnEditForm.vue?vue&type=script&lang=js"
export * from "./KnEditForm.vue?vue&type=script&lang=js"
import style0 from "./KnEditForm.vue?vue&type=style&index=0&id=dd864ade&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports